document.addEventListener("turbolinks:load", function () {
    const container = document.querySelector("#electionPage");
    if (!container) return;

    const style = document.createElement("style");
    style.innerHTML = `
      .fade-in {
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.6s ease-out, transform 0.6s ease-out;
      }

      .fade-in.visible {
        opacity: 1;
        transform: none;
      }

      .fade-delay-100 { transition-delay: 0.1s; }
      .fade-delay-200 { transition-delay: 0.2s; }
      .fade-delay-300 { transition-delay: 0.3s; }
      .fade-delay-400 { transition-delay: 0.4s; }
    `;
    document.head.appendChild(style);

    const fadeElements = container.querySelectorAll(
      "h1, p, h2, form, .relative, .space-y-4, footer"
    );

    fadeElements.forEach((el, index) => {
      el.classList.add("fade-in");
      el.classList.add(`fade-delay-${Math.min(index * 100, 400)}`);
    });

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeElements.forEach(el => observer.observe(el));
  });
